import { Alert, Button, FormContainer, Stack, TextField } from '@all-manager/design-system-v2'
import { Controller } from 'react-hook-form'
import AuthLayout from '../../../layout/AuthLayout/AuthLayout'
import { useResetPasswordPage } from './useResetPasswordPage'

export const ResetPasswordPage = () => {
  const hook = useResetPasswordPage()

  if (hook.linkError) {
    return (
      <AuthLayout title="Lien expiré ou invalide">
        <Alert severity="error">
          Ce lien de réinitialisation a expiré ou a déjà été utilisé. Demandez-en un nouveau pour choisir votre
          mot de passe.
        </Alert>
        <Stack spacing={1}>
          <Button fullWidth variant="contained" href="/forgot-password" onClick={hook.handleRequestNewLinkClick}>
            Demander un nouveau lien
          </Button>
          <Button fullWidth variant="text" href="/login" onClick={hook.handleBackClick}>
            Retour à la connexion
          </Button>
        </Stack>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout title="Nouveau mot de passe" description="Choisissez le mot de passe de votre compte.">
      <FormContainer onSubmit={hook.handleSubmit} noValidate>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          name="password"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nouveau mot de passe"
              type="password"
              autoComplete="new-password"
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Stack spacing={1}>
          <Button type="submit" fullWidth variant="contained" loading={hook.isSubmitting}>
            Enregistrer le mot de passe
          </Button>
          <Button
            fullWidth
            variant="text"
            href="/login"
            onClick={hook.handleBackClick}
            disabled={hook.isSubmitting}
          >
            Retour à la connexion
          </Button>
        </Stack>
      </FormContainer>
    </AuthLayout>
  )
}
